import request from './request'

// Obter lista de produtos
export function getProductList(params) {
  return request({
    url: '/Goods/list',
    method: 'get',
    params
  })
}

// Obter detalhes do produto
export function getProductDetail(params) {
  return request({
    url: `/Goods/detail`,
    method: 'get',
    params
  })
}

// 获取产品详情
export function getMyFavoriteGoods(params) {
  return request({
    url: `/Goods/myCollectGoods`,
    method: 'get',
    params
  })
}

// Adicionar produto aos favoritos
export function collectGoods(data) {
  return request({
    url: '/goods/collect',
    method: 'post',
    data
  })
}

export function uncollectGoods(data) {
  return request({
    url: '/goods/uncollect',
    method: 'post',
    data
  })
}

export function hasCollect(params) {
  return request({
    url: '/goods/hasCollect',
    method: 'get',
    params
  })
}



// Adicionar produto
export function addProduct(data) {
  return request({
    url: '/product',
    method: 'post',
    data
  })
}

// Atualizar produto
export function updateProduct(id, data) {
  return request({
    url: `/product/${id}`,
    method: 'put',
    data
  })
}

// Excluir produto
export function deleteProduct(id) {
  return request({
    url: `/product/${id}`,
    method: 'delete'
  })
}